import { Modifier } from "@/dto/modifier";
import {
  getFromLocalStorage,
  removeFromLocalStorage,
  saveToLocalStorage,
} from "./localStorageUtils";
import { RetailCartItem } from "@/dto/retailCartItem";
import { LocalStorageKey } from "./storageKeys";
import { DateTime } from "luxon";
import { HHMMtoDate } from "./dateTimeUtils";
import { ReadonlyURLSearchParams } from "next/navigation";
import { DayPart } from "@/dto/dayPartMenu";

export const addToCart = (item: {
  id: string;
  name: string;
  price: number;
  quantity: number;
  modifiers: Modifier[];
  specialInstructions: string;
  subtotal: number;
  total: number;
  cartId: string;
  isAgeRestricted?: boolean;
  setIsAddtocartClicked?: any;
}) => {
  const cartItem: RetailCartItem = {
    key: item.cartId,
    value: item,
  };
  const cart = getFromLocalStorage<RetailCartItem[]>(LocalStorageKey.CART, []);
  cart?.push(cartItem);
  saveToLocalStorage(LocalStorageKey.CART, cart);
  if (item.setIsAddtocartClicked) {
    item.setIsAddtocartClicked(false);
  }
};

export const getCartItems = (): RetailCartItem[] => {
  const cart = getFromLocalStorage(LocalStorageKey.CART, []);
  return cart;
};

export const clearCart = () => {
  removeFromLocalStorage(LocalStorageKey.CART);
};

export const clearServiceCart = () => {
  removeFromLocalStorage(LocalStorageKey.SERVICE_CART);
};

export const isCurrentTimePastDayPartTime = (
  cartItems: RetailCartItem[],
  isAsap: boolean = false,
  daypartEndTime: Number,
  timezone: string
): boolean => {
  if (cartItems?.length > 0 && isAsap && daypartEndTime) {
    const nowInMerchantZone = DateTime.now().setZone(timezone);
    const menuEndTime = HHMMtoDate(
      daypartEndTime.toString().padStart(4, "0"),
      timezone,
      new Date()
    );
    if (nowInMerchantZone > menuEndTime) {
      return true;
    }
  }
  return false;
};

export const removeHashFromURL = (
  hash: string,
  pathName: string,
  searchParams?: ReadonlyURLSearchParams
) => {
  if (hash !== undefined) {
    const path = `${pathName}${searchParams?.size ? `?${searchParams}` : ""}`;
    window.history.replaceState({}, "", path);
  }
};

export const getCartItemsStatus = (
  cartItems: RetailCartItem[],
  isAsap: boolean,
  dayPart: DayPart,
  timezone: string
): "past" | "inactive" | "active" => {
  /**
   * If ASAP order and daypartmenu is selected, check if current time is past the daypart menu end time. If yes, return "past"
   */
  let isPast = isCurrentTimePastDayPartTime(
    cartItems,
    isAsap,
    dayPart?.time?.endTime,
    timezone
  );

  if (isPast) return "past";

  /**
   * Check if there are any items that dont belong to current chosen daypart menu. If yes, return "Inactive"
   */
  if (
    cartItems.some(
      (item: RetailCartItem) => item.value.menuId !== dayPart?.menuId
    )
  ) {
    return "inactive";
  }

  return "active";
};
